// Configuration file for the application
const config = {
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_URL || 'https://mellowmellow.io/api',
  
  // OAuth Configuration
  GOOGLE_AUTH_URL: process.env.REACT_APP_GOOGLE_AUTH_URL || 'https://mellowmellow.io/api/auth/google',
  LINE_AUTH_URL: process.env.REACT_APP_LINE_AUTH_URL || 'https://mellowmellow.io/api/auth/line',
  
  // Frontend Configuration
  FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000',
  
  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development',
  
  // Feature Flags
  ENABLE_OAUTH: process.env.REACT_APP_ENABLE_OAUTH !== 'false',
  ENABLE_GOOGLE_LOGIN: process.env.REACT_APP_ENABLE_GOOGLE_LOGIN !== 'false',
  ENABLE_LINE_LOGIN: process.env.REACT_APP_ENABLE_LINE_LOGIN !== 'false',
};

export default config;
